export enum SmartLinkRejectReason {
  NOT_RELEVANT = 'not_relevant',
  WRONG_RECORD = 'wrong_record',
  ALREADY_LINKED = 'already_linked',
}

export const REJECT_REASONS: ReadonlyArray<{
  value: SmartLinkRejectReason;
  label: string;
}> = [
  { value: SmartLinkRejectReason.NOT_RELEVANT, label: 'Not relevant' },
  { value: SmartLinkRejectReason.WRONG_RECORD, label: 'Wrong match' },
  { value: SmartLinkRejectReason.ALREADY_LINKED, label: 'Already linked' },
];
